<template>
    <vuescroll :ops="ops" @handle-scroll="handleScroll">
        <slot></slot>
    </vuescroll>
</template>

<script>
    import vuescroll from 'vuescroll';
    import {mapActions} from "vuex";


    export default {
        name: 'scroll-hide-nav',
        components: {vuescroll},
        props: {
            navManupulation: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                active: 0,
                currentScrollPosition: 0,
                ops: {
                    vuescroll: {
                        pullRefresh: {
                            enable: true
                        },
                        pushLoad: {
                            enable: true,
                            auto: true,
                            autoLoadDistance: 10
                        }

                    },
                }
            }
        },
        methods: {
            ...mapActions([
                'visibleNav'
            ]),
            handleScroll(vertical) {
                this.$emit('handle-scroll', vertical);
                let delta = parseInt(this.currentScrollPosition - vertical.scrollTop);
                this.currentScrollPosition = vertical.scrollTop;
                if (this.navManupulation) {
                    this.visibleNav(delta);
                }
                if (Math.abs(delta) > 4) {
                   this.$emit('scroll-direction', delta >= 0);
                }
            },
        },
    }
</script>

<style scoped>

</style>
